var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrgentJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.411,
    height: 17.761,
    viewBox: "0 0 18.411 17.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "urgent-job",
    d: "M5.854,2.02a.83.83,0,0,1-.3,1.134A9.182,9.182,0,0,0,2.439,6.119a.83.83,0,1,1-1.395-.9,10.842,10.842,0,0,1,3.676-3.5A.83.83,0,0,1,5.854,2.02Zm8.525,0a.83.83,0,0,1,1.134-.3,10.843,10.843,0,0,1,3.676,3.5.83.83,0,0,1-1.395.9,9.182,9.182,0,0,0-3.113-2.965.83.83,0,0,1-.3-1.134Zm-4.262,2.4a6.641,6.641,0,1,0,6.641,6.641A6.641,6.641,0,0,0,10.117,4.423Zm-8.3,6.641a8.3,8.3,0,1,1,8.3,8.3A8.3,8.3,0,0,1,1.815,11.065Zm8.3-4.151a.83.83,0,0,1,.834.826l.019,4.151a.83.83,0,0,1-1.66.007L9.286,7.748A.83.83,0,0,1,10.113,6.914Zm0,6.625a.83.83,0,0,1,.83.83v.016a.83.83,0,1,1-1.66,0v-.016A.83.83,0,0,1,10.117,13.539Z",
    transform: "translate(-0.911 -1.605)",
    fill: "#ffbe00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentJob);
export default __webpack_public_path__ + "static/media/urgent-job.48e7fa34c43fbd3d6015890ed55bf2a2.svg";
export { ForwardRef as ReactComponent };